import { render, staticRenderFns } from "./EventManage.vue?vue&type=template&id=4868de23&scoped=true&"
import script from "./EventManage.vue?vue&type=script&lang=js&"
export * from "./EventManage.vue?vue&type=script&lang=js&"
import style0 from "./EventManage.vue?vue&type=style&index=0&id=4868de23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4868de23",
  null
  
)

export default component.exports